var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BannerSection'),_c('Portfolio',{attrs:{"title":"Our recent work","path":_vm.path}}),_c('CompanyStats'),_c('Testimonials')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }